module.exports = __webpack_public_path__ + "img/c14.5ff810be.png";